import React from "react";
import styled from "styled-components";
import TouchableCardBase from "./TouchableCardBase";
import { Grid, GridSize } from "@material-ui/core";

// TODO: Rename
const PaddingGrid = styled(Grid)`
  padding-right: 8px;
`;

interface Props {
  onClick?: () => void;
  eventClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  title?: React.ReactNode;
  subtitles?: React.ReactNodeArray;
  actions?: React.ReactNodeArray;
  mediumSpan?: GridSize;
  actionbutton?: React.ReactNode;
  backgroundColor?: string;
  "data-cy"?: string;
}

const ListCard: React.FC<Props> = ({
  onClick,
  eventClick,
  title,
  subtitles,
  actions,
  mediumSpan = 3,
  actionbutton,
  backgroundColor,
  ...rest
}) => {
  return (
    <TouchableCardBase
      onClick={onClick}
      eventClick={eventClick}
      backgroundcolor={backgroundColor}
      data-cy={rest["data-cy"]}
    >
      <Grid
        container
        justify={
          subtitles && subtitles.length > 4 ? "flex-start" : "space-between"
        }
      >
        {title ? (
          <Grid item xs={12}>
            {title}
          </Grid>
        ) : null}

        {actionbutton === undefined ? (
          subtitles ? (
            subtitles.map((subtitle, index) => (
              <Grid
                key={"subtitle_" + index}
                item
                xs={12}
                sm={mediumSpan > 6 ? mediumSpan : 6}
                md={mediumSpan}
              >
                {subtitle}
              </Grid>
            ))
          ) : null
        ) : (
          <>
            <Grid container item xs={12} sm={6} md={10}>
              {subtitles
                ? subtitles.map((subtitle, index) => (
                    <Grid
                      key={"subtitle_" + index}
                      item
                      xs={12}
                      sm={6}
                      md={mediumSpan}
                    >
                      {subtitle}
                    </Grid>
                  ))
                : null}
            </Grid>
            <Grid container item xs={12} sm={6} md={2} justify="flex-end">
              {actionbutton}
            </Grid>
          </>
        )}
      </Grid>
      {actions ? (
        <PaddingGrid container justify="flex-end">
          {actions.map((action, index) => (
            <Grid item key={"action_" + index}>
              {action}
            </Grid>
          ))}
        </PaddingGrid>
      ) : null}
    </TouchableCardBase>
  );
};

export default ListCard;
